// extracted by mini-css-extract-plugin
module.exports = {"doc-page-wrapper":"F_cQ container-lg d-flex p-3","doc-page":"F_cR","doc-page__title--enterprise":"F_cS","doc-page--with-side-menu":"F_cT","doc-page__title":"F_cV"};